import { render, staticRenderFns } from "./ChoosePreferredPhotoitemList.vue?vue&type=template&id=24356c30&"
import script from "./ChoosePreferredPhotoitemList.vue?vue&type=script&lang=js&"
export * from "./ChoosePreferredPhotoitemList.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePreferredPhotoitemList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports